import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { TextField, FontIcon, Dialog, FlatButton } from 'material-ui';
import { isEmpty, append, either, isNil, not } from 'ramda';
import { isValidEmail } from '../../../../utils/validations';

const isNilOrEmpty = either(isNil, isEmpty);

const AddIndividually = props => {
  const {
    updateProps,
    sendToPartners,
    processPartners,
  } = props;

  const textFields = [
    {
      cyData: 'companyNameInput',
      icon: 'tc-icon-office',
      iconStyle: { color: '#757575', lineHeight: '1', margin: '0px 28px 0px 7px' },
      label: 'Company Name (optional)',
      func: ({ target: { value } }) => updateProps({ individualCompanyName: value }),
    },
    {
      cyData: 'emailInput',
      icon: 'tc-icon-email',
      iconStyle: { color: '#757575', margin: '0px 28px 0px 10px', fontSize: '20px' },
      label: 'Email (REQUIRED)',
      func: ({ target: { value } }) => updateProps({ individualEmail: value }),
    },
  ];

  return (
    <Dialog
      open={sendToPartners.showAddIndividuallyDialog}
      actions={[
        <FlatButton
          data-cy="addIndividuallyCancel"
          label="Cancel"
          primary
          labelStyle={{ fontWeight: '600' }}
          onTouchTap={() => updateProps({
            showAddIndividuallyDialog: false,
            addPartnersMethod: '',
          })}
        />,
        <FlatButton
          data-cy="addIndividuallyContinue"
          label="ADD"
          secondary
          labelStyle={{ fontWeight: '600' }}
          onTouchTap={() => processPartners({
            showAddIndividuallyDialog: false,
            partnersToSendTo: not(isNilOrEmpty(sendToPartners.individualCompanyName)) ? append({
              companyName: sendToPartners.individualCompanyName,
              email: sendToPartners.individualEmail,
            }, sendToPartners.partnersToSendTo) :
            append({
              email: sendToPartners.individualEmail,
            }, sendToPartners.partnersToSendTo),
            individualCompanyName: '',
            individualEmail: '',
          })}
          disabled={isEmpty(sendToPartners.individualEmail)}
        />,
      ]}
      title="Add Individually"
      contentStyle={{ width: '512px' }}
      bodyStyle={{ paddingTop: '0' }}
    >
      {
        textFields.map((field, i) => {
          return (
            <div className="add-individ-connection-dialog" key={i}>
              <FontIcon
                className={field.icon}
                style={field.iconStyle}
              />
              <TextField
                data-cy={field.cyData}
                floatingLabelText={field.label}
                floatingLabelStyle={{ fontSize: '1.1vw' }}
                style={{ width: '85%', marginBottom: '20px' }}
                onChange={field.func}
              />
            </div>
          );
        })
      }
    </Dialog>
  );
};

AddIndividually.propTypes = {
  updateProps: PropTypes.func,
  sendToPartners: PropTypes.object,
};

const mapStateToProps = ({ contracting }) => ({
  sendToPartners: contracting.sendToPartners.toJS(),
});

export default connect(mapStateToProps)(AddIndividually);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/send-to-partners/add-individually.jsx